// extracted by mini-css-extract-plugin
module.exports = {"forecastedValue":"WindStats_forecastedValue__jNVGU","dataLagging":"WindStats_dataLagging__iFW6t"};